import { ObservableFromFetch } from "../ObservableFromFetch"
import { ImplementationGroupID_Workforce } from "../../config/Constants"
import ImplementationData from "./Model/ImplementationData"
import GridResponse from "../GridResponse"

export type UserDetailGridResponse = GridResponse<ImplementationData>

export default function ImplementationsGetObservable() {
  const requestBody: string = JSON.stringify({ ImplementationGroupID: ImplementationGroupID_Workforce, SortGrid: { SortColumn: "Name", SortOrder: "ASC" }, ReturnAll: true })
  return ObservableFromFetch<UserDetailGridResponse>("/SuperUser/ImplementationDetails", requestBody)
}
